import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M23,26a1,1,0,0,1-1-1V12a1,1,0,0,1,2,0V25A1,1,0,0,1,23,26Z"/><path d="M26.72,6.82,14.36,2.07a1,1,0,0,0-.93.11A1,1,0,0,0,13,3v9H6a2,2,0,0,0-2,2V28a2,2,0,0,0,2,2H26a2,2,0,0,0,2-2V8.69A2,2,0,0,0,26.72,6.82ZM6,28V14h9V28Zm20,0H17V14a2,2,0,0,0-2-2V4.46L26,8.69Z"/><rect x="18" y="9" width="2" height="17" rx="1"/><rect x="8" y="16" width="5" height="2" rx="1"/><rect x="8" y="20" width="5" height="2" rx="1"/><rect x="8" y="24" width="5" height="2" rx="1"/>';
export var BuildingsOutlineSVG = function BuildingsOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
BuildingsOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(BuildingsOutlineSVG);